<!-- main navbar -->
<nav class="navbar navbar-expand-lg bg-light">
  <div class="container-fluid">
    <a class="navbar-brand" href="#">
      <img style="height: 45px;" [src]="'../assets/images/' + logo" alt="State Logo">
    </a>

    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbar-login"
            aria-controls="navbar-login" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse justify-content-end" id="navbar-login">
      <ul class="navbar-nav mb-2 mb-lg-0 m-0">
        <li class="" [ngClass]="{'active': currentRoute == 'login'}" id="home">
          <a class="nav-link" [routerLink]="['/login']" [ngClass]="{'active-link': currentRoute == 'login','no-link': currentRoute != 'login'}">Home</a>
        </li>

        <li class="" [ngClass]="{'active': currentRoute == 'about'}" id="aboutUs">
          <a class="nav-link" [routerLink]="['/about']" [ngClass]="{'active-link': currentRoute == 'about','no-link': currentRoute != 'about'}">About Us</a>
        </li>

<!--        <li class="" id="aboutCEMS">-->
<!--          <a class="nav-link">About CEMS</a>-->
<!--        </li>-->

        <li class="" [ngClass]="{'active': currentRoute == 'publicSlideshow'}" id="publicSlideshow">
          <a class="nav-link" [routerLink]="['/publicSlideshow']" [ngClass]="{'active-link': currentRoute == 'publicSlideshow','no-link': currentRoute != 'publicSlideshow'}">Slideshow</a>
        </li>

        <li class="" [ngClass]="{'active': currentRoute == 'public'}" id="publicAccess">
          <a class="nav-link" [routerLink]="['/public']" [ngClass]="{'active-link': currentRoute == 'public','no-link': currentRoute != 'public'}">Public Access</a>
        </li>

        <li class="" [ngClass]="{'active': currentRoute == 'djb-dashboard'}" id="djb-daashboard">
          <a class="nav-link" [routerLink]="['/djb-dashboard']" [ngClass]="{'active-link': currentRoute == 'djb-dashboard','no-link': currentRoute != 'djb-dashboard'}">DJB Dashboard</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
<!-- /main navbar -->
